import * as React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import img_base from '../img/image.png'

export default function PersonCard({ name, text, number, img, locale }) {
    let position = locale === 'ru' ? 'Должность:': 'Post:';
    let phone_number = locale === 'ru' ? 'Телефон:': 'Phone number:';
    const API_URL = process.env.REACT_APP_STRAPI_URL;
    return (
        <Paper sx={{ width: {xs: '300px', md: "350px"}, height: '150px', m: 2}}>
            <Stack sx={{ m: 3, pt: 1 }}>
                <Stack direction="row" alignItems='center' spacing={2} sx={{ flexWrap: 'nowrap', mb: 2 }}>
                    <Avatar
                        variant='circular'
                        content={img ? API_URL + img : img_base}
                        size='40px'
                    />
                    <Typography component="div">
                        {name}
                    </Typography>
                </Stack>
                <Stack>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {position}{text}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {phone_number}{number}
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    );
}